const errorMessageBinding = {
  0: 'Erreur lors du télécharment de votre stock',
  500: 'Une erreur est survenue, veuillez nous excuser pour la gêne occasionnée 😅',
  212005: 'Le code de validation incorrect',
  211027: "Le type d'utilisateur est incorrect",
  211002: "L'email est vide",
  211003: "L'email est invalide",
  211004: "L'email est trop long (100 caractères max)",
  211001: "L'adresse email est déjà utilisé par un autre compte",
  211010: 'Le numéro de téléphone est vide',
  211009: 'Le numéro de téléphone est déjà utilisé par un autre compte',
  216001: "Le nom de l'entreprise est vide",
  216003: "Le numéro de SIRET n'a pas une longueur valide (14 caractères)",
  235002: 'Le type de token demandé est invalide',
  220012: "Aucune invitation ne correspond à l'email et au code de confirmation donnés",
  203001: 'Le champ ville est vide',
  203002: 'La ville est trop longue (255 caractères max)',
  203003: "Le complément d'adresse est trop long (255 caractères max)",
  205001: 'Le code pays est invalide',
  203005: 'Le code postal est trop long (255 caractères max)',
  203006: "L'état est trop long (100 caractères max)",
  203007: "La ligne 2 de l'adresse est trop longue (255 caractères max)",
  203008: "La ligne 1 de l'adresse est vide",
  203009: "La ligne 1 de l'adresse est trop longue (255 caractères max)",
  206001: 'La monnaie utilisée dans les déclarations douanières est invalide',
  206002: "Le montant spécifié dans les déclarations douanières n'est pas un montant numérique valide",
  206003: "Le type d'objet dans les déclarations douanières est vide",
  206004: "Le type d'objet dans les déclarations douanières est trop long (100 caractères max)",
  206005: "La quantité spécifiée dans les déclarations douanières n'est pas un entier valide",
  207001: "L'adresse de livraison est invalide (il faut spécifier une adresse ou un point relais)",
  207002: "L'identifiant de l'adresse de livraison fourni est invalide",
  207003: 'Les déclarations douanières ne sont pas dans le bon format',
  207004: "Le code de l'offre choisie est invalide",
  207005: "L'identifiant du point relais spécifié est invalide",
  207006: 'La photo de la commande est manquante',
  207007: 'La photo doit être une image au format JPEG',
  207008: "L'email du destinataire est vide",
  207009: "L'email du destinataire est invalide",
  207010: 'Le prénom du destinataire est vide',
  207011: 'Le prénom du destinataire est trop long (255 caractères max)',
  207012: 'Le nom de famille du destinataire est vide',
  207013: 'Le nom de famille du destinataire est trop long (255 caractères max)',
  207014: 'Le numéro de téléphone du destinataire est invalide',
  207027: 'Le type de la commande est invalide',
  207030: 'Le type de livraison est invalide',
  207038: "Le nom de l'entreprise destinataire est vide",
  207047: 'La commande doit avoir soit une photo, soit une référence pour la commande ainsi que les références de chacun des objets',
  204003: "L'id de l'adresse de récupération est invalide",
  208007: "Le paramètres « commands » n'est pas dans le bon format",
  208011: 'Un ID est manquant dans le tableau de commandes',
  207016: 'Un des ID fournis ne correspond à aucune commande',
  208008: "Le client n'a pas le droit de demander un enlèvement pour cette liste de commande (par exemple si une commande ne lui appartient pas)",
  208014: "La zone n'est pas desservie",
  208015: "Le paramètres « commands » n'est pas dans le bon format",
  208017: 'Une course est déjà en cours',
  211020: "Le numéro de téléphone du client n'a pas été renseigné",
  211021: "L'email du client n'a pas été renseigné",
  211022: "Le prénom du client n'a pas été renseigné",
  211023: "Le nom du client n'a pas été renseigné",
  211024: "Le nom de l'entreprise du client n'a pas été renseigné",
  211025: "Le SIRET de l'entreprise du client n'a pas été renseigné",
  211026: "Le numéro de TVA de l'entreprise du client n'a pas été renseigné",
  221001: "Le paiement a échoué. Inviter l'utilisateur à renseigner un moyen de paiement valide.",
  211005: 'Le prénom est vide',
  211006: 'Le prénom est trop long (50 caractères max)',
  211007: 'Le nom de famille est vide',
  211008: 'Le nom de famille est trop long (50 caractères max)',
  211011: "La photo fournie n'est pas au format JPEG",
  220001: "L'email est vide",
  220002: "L'email est invalide",
  220003: "L'email est trop long (100 caractères max)",
  220004: 'Le prénom est vide',
  220005: 'Le prénom est trop long (50 caractères max)',
  220006: 'Le nom de famille est vide',
  220007: 'Le nom de famille est trop long (50 caractères max)',
  220008: 'Le numéro de téléphone est vide',
  220009: 'Le collaborateur a déjà un compte professionnel (il est rattaché à une autre entreprise)',
  220010: "L'utilisateur doit être un professionnel",
  220011: "L'utilisateur doit être l'administrateur du compte entreprise",
  204004: "L'utilisateur n'a pas le droit de supprimer cette adresse (parce qu'elle ne lui appartient pas)",
  204006: "L'adresse souhaitant être supprimée est l'adresse de facturation",
  207026: 'La commande ne peux pas être mise à jour',
  202006: 'Aucune entreprise existe avec cette id',
  212008: "Le format du token d'authentification est invalide",
  211012: 'Utilisateur introuvable',
  207040: "La commande n'est pas dans un état permettant sa modification",
  207059: 'Les items ne sont pas au bon format'
};

export default errorMessageBinding;
